import React from "react";
import GameInstructionModal from "./GameInstructionModal";

const ModalRainDrop = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Raindrop"
      gamePath="/userDashboard/game/rain-drop"
      icon="solar:cloud-rain-bold"
      instructions={[
        "Patch your better eye.",
        "Move the white paddle at the bottom using your mouse / trackpad.",
        "Catch the falling black drops on the paddle to prevent them from dropping off screen."
      ]}
      isBinocular={false}
    />
  );
};

export default ModalRainDrop;
